// Article pages live at /articles/<article_id>/<slug>. The ID resolves the
// page; the slug is cosmetic and follows the title, so a stale slug still works.
export const articlePath = (articleId, slug) =>
  slug ? `/articles/${articleId}/${slug}` : `/articles/${articleId}`;

// { articleId, slug } from an article page URL (absolute or site-relative), or
// null when the URL isn't one.
export const parseArticleUrl = (url) => {
  const match = String(url || "").match(/\/articles\/(\d+)(?:\/([^/?#]+))?/);
  return match ? { articleId: Number(match[1]), slug: match[2] ?? "" } : null;
};
